import React, { forwardRef, useEffect, useState } from 'react'
import { MapContainer, TileLayer } from 'react-leaflet'
import LocationMarker from './LocationMarker'
import { LatLngExpression } from 'leaflet'
interface ATMapProps {
  latitude?: any
  longitude?: any
  radius?: number
  plantName?: string
}

const ATMap = forwardRef((props: ATMapProps, ref) => {
  const { latitude = 0, longitude = 0, radius = 0, plantName } = props
  const [center, setCenter] = useState<LatLngExpression>([latitude, longitude])

  useEffect(() => {
    if (latitude !== 0 && longitude !== 0) {
      setCenter([latitude, longitude])
    }
  }, [latitude, longitude])

  return (
    <MapContainer center={center} zoom={10} scrollWheelZoom={false}>
      <TileLayer
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />
      <LocationMarker
        latitude={latitude}
        longitude={longitude}
        radius={radius}
        plantName={plantName}
        ref={ref}
      />
    </MapContainer>
  )
})

export default ATMap
